import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { studentNotificationModel } from "./student-assignment-data-model";

export class studentNotificationGridModel extends studentNotificationModel { }

export class studentNotificationListingModel extends GridModel<studentNotificationGridModel> { }
export class studentNotificationGridPostParams extends GridPostParams {
    
}